<template>
    <div>
  <Navbar />
  <!-- Start Team Area -->
      <section class="team-section pt-100 pb-70">
        <div class="container">
          <div class="team-title-area">
            <div class="row align-items-center">
              <div class="col-lg-7">
                <div class="section-title text-left">
                <span>
                  <i class="flaticon-support"></i>
                  Meet Our Leaders
                </span>
                  <h2>BLI Leadership</h2>
                  <p>

                  </p>
                </div>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/bli/bli_leaders1.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content" style="height:24rem">
                  <h3>GAOLEBALE ISAAC</h3>
                  <span>Chairman, BLI </span>
                  <span>Pastor Isaac Gaolebale, fondly nicknamed Bishop by Dr. Goodhead has remained one of the most dedicated members and leaders of the RPC, BLI and CLC, the three realms where he holds leadership positions.Educationally, Bishop holds Bachelor of Education (Sci) in Pure and Applied Mathematics and a Master of Science in Financial Management, Amity University India. Bishop is married to Madam Isaac and the two are blessed with three lovely kids</span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/bli/bli_leaders2.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content" style="height:24rem">
                  <h3>RUDOLPH NDUBANO</h3>
                  <span>Program Director, BLI</span>
                  <span>Rudolph Ndubao is a prophet and son of a prophet. He has grown all his life within the perimeter of the church with his parents being preachers and leaders of many Christian organizations. Rudoplh is a self-schooled highly intelligent man. As a farmer and a preacher, who sees the church as God’s field, he minsters the word of God by relating his personal experience from the farm with the scriptures; teaching mostly with stories. Rudolph is the Program Director of the Business and Leadership Institute of the CLC Botswana.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  <!-- End Team Area -->
  <Footer />
    </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "../../Footer";
export default {
  name: "Team",
  components: { Footer, Navbar }
};
</script>

<style scoped>
.team-image {
  height: 300px;
}
</style>
